import { FORCE_UPDATE_ORDER, GET_BOOKED_ORDERS, UPDATE_ORDER, UPDATE_ORDERS } from "./bookedOrders.actionsTypes";

import { ORDER_STATUSES } from "../../config/constants";

import diff from "deep-diff";

const updateSupplier = (suppliers, order) => {
    suppliers.forEach((supplier) => {
        const shops = order.shops || [];
        shops.forEach((shop) => {
            if (shop._id === supplier.id && supplier.hasOwnProperty("status")) {
                shop.status = supplier.status;
            }
            if (shop._id === supplier.id && supplier.hasOwnProperty("state")) {
                shop.state = supplier.state;
            }
        });
    });
};

const updateOrder = (state, order) => {
    order?.__v && localStorage.setItem("v", order.__v);
    return state.map((item) => {
        const id = order._id || order.orderId || order.id;
        if (item.orderId === id || id === item._id) {
            const suppliers = order.suppliers;
            let distributorRejectionReasons = order.distributorRejectionReasons;
            delete order.suppliers;
            if (
                order.hasOwnProperty("status") &&
                item.status !== order.status
            ) {
                item.rejectedBlink =
                    item.status === ORDER_STATUSES.REJECTED.statusId;
            }
            if (
                distributorRejectionReasons &&
                !Array.isArray(distributorRejectionReasons)
            ) {
                const list = item.distributorRejectionReasons || [];
                list.push(distributorRejectionReasons);
                order.distributorRejectionReasons = list;
            }
            Object.assign(item, order);
            if (suppliers) {
                updateSupplier(suppliers, item);
            }
        }
        return item;
    });
};

const sortOrders = (orders) => {
    orders.sort((a, b) => {
        if (
            a.status === ORDER_STATUSES.DRAFT.statusId &&
            b.status !== ORDER_STATUSES.DRAFT.statusId
        ) {
            return -1;
        } else if (
            a.status !== ORDER_STATUSES.DRAFT.statusId &&
            b.status === ORDER_STATUSES.DRAFT.statusId
        ) {
            return 1;
        }
        if (a.eta < b.eta) {
            return -1;
        } else if (a.eta > b.eta) {
            return 1;
        }
        return a.orderId - b.orderId;
    });
};

const removeFinishedOrders = (orders) => {
    return orders.filter((order) => {
        return (
            order.status !== ORDER_STATUSES.DELIVERED.statusId &&
            order.status !== ORDER_STATUSES.CANCELED.statusId
        );
    });
};

const finalizeOrders = (orders) => {
    sortOrders(orders);
    return removeFinishedOrders(orders);
};

export default function bookedOrders(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case UPDATE_ORDERS:
            action.orders.map((order) => {
                updateOrder(newState, order);
                return order;
            });
            return finalizeOrders(newState);
        case UPDATE_ORDER:
            return finalizeOrders(updateOrder(newState, action.order));
        case GET_BOOKED_ORDERS:
            let orders = Object.assign([], action.orders);
            orders = finalizeOrders(orders);
            return orders;
        case FORCE_UPDATE_ORDER:
            const newOrder = action.order;
            const newOrders = newState.map((order) => {
                if (order._id === action.order._id) {
                    if (order.userUpdate) {
                        action.order.blink = false;
                    } else {
                        const differences = diff(
                            order,
                            newOrder,
                            (path, key) => {
                                return (
                                    key === "blink" ||
                                    key === "rejectedBlink" ||
                                    key === "userUpdate" ||
                                    key === "updatedByWeb"
                                );
                            }
                        );
                        newOrder.differences = differences;
                    }
                    // For order detail view
                    order.shops = newOrder.shops;
                    order = newOrder;
                }
                return order;
            });
            return finalizeOrders(newOrders);
        default:
            return newState;
    }
}
